import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { checkUrlLocale } from '../utils/check-url-locale';

/**
 * Function which returns the canonicalLink of the current page as a string
 * @function CanonicalLink
 * @param isRegionalContent {Boolean}
 * @param contentType {String}
 * @param contentSlug {String}
 * @param onSeoSlugChange {function}
 * @returns {JSX}
 */

const CanonicalLink = ({ isRegionalContent, contentType, contentSlug, onSeoSlugChange }) => {
  const locale = checkUrlLocale();
  const baseUrl = 'https://www.credera.com';
  // Remove leading and trailing slashes from contentType and contentSlug
  const sanitizedContentType = contentType.replace(/^\/|\/$/g, '');
  const sanitizedContentSlug = contentSlug.replace(/^\/|\/$/g, '');
  const resourcePath = `${sanitizedContentType}/${sanitizedContentSlug}`;
  const canonicalUrl = locale ? `${baseUrl}${locale}/${resourcePath}` : `${baseUrl}/${resourcePath}`;
  const seoSlug = locale ? `${locale}/${resourcePath}` : `${resourcePath}`;
  const hrefLangNoSlash = locale ? locale.slice(1) : '';

  useEffect(() => {
    onSeoSlugChange(seoSlug);
  }, [seoSlug, onSeoSlugChange]);

  // Regex to validate the canonical url containing // or /// returning 404 err
  const isValidUrl = url => {
    const regex = /^(https?:\/\/)(?!.*\/\/).*$/;
    return regex.test(url);
  };

  return (
    <>
      {!isRegionalContent &&
        (locale ? (
          <link rel="alternate" hrefLang={hrefLangNoSlash} href={canonicalUrl} />
        ) : (
          isValidUrl(canonicalUrl) && <link rel="canonical" href={canonicalUrl} />
        ))}
    </>
  );
};

CanonicalLink.propTypes = {
  isRegionalContent: PropTypes.bool.isRequired,
  contentType: PropTypes.string.isRequired,
  contentSlug: PropTypes.string.isRequired,
  onSeoSlugChange: PropTypes.func.isRequired
};

export default CanonicalLink;
